import React, { useContext } from 'react';
import { RicosContext, RicosViewerContext } from 'ricos-context';
import { VERTICAL_EMBED_TYPE } from './viewer-loadable.js';
import { v as verticalEmbedProviders, c as convertDuration, s as styles, C as Card } from './Card.js';
import classNames from 'classnames';
import { getLangDir } from 'wix-rich-content-common';
import '@loadable/component';
import 'ricos-types';
import 'ricos-schema';
import 'lodash';
import 'prop-types';
import 'wix-rich-content-common/libs/Tooltip';
import 'wix-rich-content-common/libs/imageUtils';

var _contentTypeMapGetter;
var getBookingContent = function getBookingContent(_ref, t) {
  var name = _ref.name,
    durations = _ref.bookingData.durations;
  return {
    title: name,
    info: {
      leftSubtitle: durations && convertDuration(durations, t)
    },
    buttonText: t("VerticalEmbed_Bookings_Button")
  };
};
var getEventContent = function getEventContent(_ref2, t) {
  var name = _ref2.name,
    _ref2$eventData = _ref2.eventData,
    scheduling = _ref2$eventData.scheduling,
    location = _ref2$eventData.location;
  return {
    title: name,
    info: {
      leftSubtitle: scheduling,
      rightSubtitle: location
    },
    buttonText: t("VerticalEmbed_Events_Button")
  };
};
var getProductContent = function getProductContent(_ref3, t) {
  var name = _ref3.name;
  return {
    title: name,
    buttonText: t("VerticalEmbed_Products_Button")
  };
};
var contentTypeMapGetter = (_contentTypeMapGetter = {}, _contentTypeMapGetter[verticalEmbedProviders.booking] = getBookingContent, _contentTypeMapGetter[verticalEmbedProviders.event] = getEventContent, _contentTypeMapGetter[verticalEmbedProviders.product] = getProductContent, _contentTypeMapGetter);
var verticalsDataBuilder = function verticalsDataBuilder(componentData, t, changeBaseUrl) {
  if (changeBaseUrl === void 0) {
    changeBaseUrl = function changeBaseUrl(x) {
      return x;
    };
  }
  var url = componentData.url,
    image = componentData.image;
  return {
    url: changeBaseUrl(url),
    imageSrc: image.src.url,
    imageWidth: image.width,
    imageHeight: image.height,
    content: contentTypeMapGetter[componentData.type.toLowerCase()](componentData, t)
  };
};

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var VerticalEmbedViewer = function VerticalEmbedViewer(_ref) {
  var _classnames;
  var settings = _ref.settings,
    componentData = _ref.componentData,
    helpers = _ref.helpers;
  var _useContext = useContext(RicosContext),
    t = _useContext.t,
    locale = _useContext.locale;
  var onClick = function onClick() {
    var _a;
    return (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, VERTICAL_EMBED_TYPE, "Click", componentData.type);
  };
  var props = verticalsDataBuilder(componentData, t, settings.changeBaseUrl);
  var direction = getLangDir(locale);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /* @__PURE__ */
    React.createElement("div", {
      className: classNames(styles.card, (_classnames = {}, _classnames[styles.slimLayout] = settings.slimLayout, _classnames)),
      "data-hook": "vertical-embed",
      onClick: onClick
    }, /* @__PURE__ */React.createElement(Card, __spreadProps(__spreadValues({}, props), {
      t: t,
      direction: direction,
      disabled: settings.disabled
    })))
  );
};

var VerticalEmbed = function VerticalEmbed(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  var _useContext = useContext(RicosViewerContext),
    helpers = _useContext.helpers,
    config = _useContext.config;
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    node: node,
    nodeIndex: nodeIndex
  }, /* @__PURE__ */React.createElement(VerticalEmbedViewer, {
    settings: config[VERTICAL_EMBED_TYPE] || {},
    componentData: node.appEmbedData,
    helpers: helpers
  }));
};

export { VerticalEmbed as default };

import 'wix-rich-content-plugin-vertical-embed/dist/loadable/viewer/es/styles.viewer.min.global.css'